module.exports = __webpack_public_path__ + "static/media/indian-farmer-using-smartphone.8a9b5c9c.jpg";